import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export interface CustomInvoiceHistoryType {
    tabSelected: number;
}

export type CustomInvoiceHistoryState = Readonly<CustomInvoiceHistoryType>;

const initialInvoiceHistoryState: CustomInvoiceHistoryState = {
    tabSelected: 0,
};

export const customInvoiceHistoryReducer = createTypedReducer(initialInvoiceHistoryState, {
    "Custom/InvoiceHistory/SetOptionSelected": (
        draft: Draft<CustomInvoiceHistoryState>,
        { tabSelected }: { tabSelected: number },
    ) => ({
        ...draft,
        tabSelected,
    }),
});
